import { render } from "./LbrxTechnicialAssistancePopup.vue?vue&type=template&id=facf3a46&scoped=true"
import script from "./LbrxTechnicialAssistancePopup.vue?vue&type=script&lang=js"
export * from "./LbrxTechnicialAssistancePopup.vue?vue&type=script&lang=js"

import "./LbrxTechnicialAssistancePopup.vue?vue&type=style&index=0&id=facf3a46&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-facf3a46"]])

export default __exports__